import React, { Fragment, useState, useEffect } from 'react';
import { Card, Col, Container } from 'reactstrap';
import { useAgreement } from '../../../hooks/agreements/useAgreement';
import { ModalAgreement } from '../../../components/agreement/ModalAgreement';
import './StyleAgreementCard.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';




export const IndexAgreements = () => {

    const {

        // ? DATA 
        modal, modalTitle, toggle, method, loading, name_company, contract_number, validity, status,
        navigateNewAgreement, navigateUpdate, agreements,

        // ? METHODS GLOBALS
        handleDelete, saveDelete, handleUpdateStatus, saveUpdateStatus,

        //*dowload excel 
        downdloadExcel, exportExcel, id_branch,


        // * DELETE AGREEMENT
        confirmationDelete, isDelete, valueCode, setValueCode

    } = useAgreement();
    console.log("🚀 ~ IndexAgreements ~ agreements:", agreements)


    const headerStyle =
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "10px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle =
    {
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };


    const renderPayMethod = (items) => {

        const baseStyle = { fontSize: "12px", textAlign: "center" };

        const _status = items.status

        if (_status) {
            return <Tag style={baseStyle} severity="success" value={"Aprobado"} />;
        }
        else {
            return <Tag style={baseStyle} severity="warning" value={"Revisión"} />;
        }
    };


    const renderExpiration = (items) => {

        const baseStyle = {
            fontSize: "12px",
            textAlign: "center",
            width: "40px",
            display: "inline-flex",
            justifyContent: "center"
        };

        const _status = items.expiracion;

        return _status
            ? <Tag style={baseStyle} severity="danger" value="NO" />
            : <Tag style={baseStyle} severity="success" value="SI" />;
    };


    const [globalFilter, setGlobalFilter] = useState("");


    useEffect(() => {
        const savedFilter = localStorage.getItem('globalFilter');
        if (savedFilter) {
            setGlobalFilter(savedFilter);
        }
    }, []);

    useEffect(() => {
        if (globalFilter) {
            localStorage.setItem('globalFilter', globalFilter);
        } else {
            localStorage.removeItem('globalFilter');
        }
    }, [globalFilter]);


    const handleClearFilter = () => {
        setGlobalFilter("");
    };



    const filterData = (data, filter) => {
        return data.filter(row => {

            const name_company = row?.name_company ?? "-----";
            const contract_number = row?.contract_number ?? "-----";
            const financing_method_name = row?.financing_method_name ?? "-----";
            const validity = row?.validity ?? "-----";
            const agreement_mode = row?.agreement_mode ?? "-----";
            const lowerCaseFilter = filter.toLowerCase();



            return (
                name_company.toLowerCase().includes(lowerCaseFilter) ||
                contract_number.toLowerCase().includes(lowerCaseFilter) ||
                financing_method_name.toLowerCase().includes(lowerCaseFilter) ||
                validity.toLowerCase().includes(lowerCaseFilter) ||
                agreement_mode.toLowerCase().includes(lowerCaseFilter)
            );
        });
    };



    return (
        <Fragment>
            <div className='container-global-zoom' >
                <Card  >
                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                        <TitleDataTable
                            titleTable="Listado de convenios"
                            buttonActions={exportExcel}
                            titleButton="Descargar listado"
                            isDisbled={false}
                            titleCreate="Crear convenio"
                            buttonActionsCreate={navigateNewAgreement}
                            actionInput={setGlobalFilter}
                            valueFilter={globalFilter}
                            filterLocalStorage={true}
                            cleanFilterLocalStorage={handleClearFilter}
                        />
                    </Col>

                    <Col sm="12" className='pt-3'>

                        <div className="table-responsive" >
                            <DataTable
                                className="data-table"
                                value={filterData(agreements, globalFilter)}
                                paginator
                                rows={10}
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "25%" }}
                                            alt="Sin Muestras"
                                        />
                                        <br />
                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                            No hay un registro.
                                        </p>
                                    </div>
                                }
                                rowsPerPageOptions={[10, 50, 100]}
                                stripedRows
                                responsiveLayout="scroll"

                            >
                                <Column
                                    body={(rowData, { rowIndex }) => rowIndex + 1}
                                    header="#"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field='id_agreement'
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center", fontWeight: "bold" }}>
                                            {rowData?.contract_number ?? "-----"}
                                        </label>
                                    )}
                                    header="N° de contrato"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="contract_number"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.name_company ?? "-----"}
                                        </label>
                                    )}
                                    header="Empresa"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="name_company"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label className='badge badge-light-primary' style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.agreement_mode ?? "-----"}
                                        </label>
                                    )}
                                    header="Modo de convenio"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="agreement_mode"
                                />
                                <Column
                                    header="Vigencia"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    body={(rowData) => (
                                        <div className="d-flex justify-content-center">
                                            {renderExpiration(rowData)}
                                        </div>
                                    )}
                                    sortable
                                    field="expiracion"
                                />
                                <Column
                                    body={(rowData) => (
                                        <label style={{ fontSize: "11px", textAlign: "center" }}>
                                            {rowData?.validity ?? "-----"}
                                        </label>
                                    )}
                                    header="Validos hasta"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    sortable
                                    field="validity"
                                />

                                <Column
                                    header="Estatus"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    body={(rowData) => (
                                        <div className="d-flex justify-content-center">
                                            {renderPayMethod(rowData)}
                                        </div>
                                    )}
                                    sortable
                                    field="status"
                                />



                                <Column
                                    header="Acciones"
                                    headerStyle={{ ...headerStyle, textAlign: "center" }}
                                    body={(rowData) => {
                                        const objId = rowData.id_agreement;
                                        return (
                                            <div className="d-flex justify-content-center">
                                                <button
                                                    onClick={() => handleUpdateStatus(rowData.id_agreement)}
                                                    title={rowData.status ? "Desactivar" : "Activar"}
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "3px"
                                                    }}
                                                    className={`btn ${rowData.status ? 'btn-successs' : 'btn-naranja '}`}
                                                >
                                                    {rowData.status ? <i className='icofont icofont-ui-check'></i> : <i className='fa fa-times  '></i>}
                                                </button>

                                                {!rowData.status && (
                                                    <button
                                                        onClick={() => navigateUpdate(rowData.id_agreement)}
                                                        title="Editar"
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            fontSize: "0.65rem",
                                                            borderRadius: "8px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginRight: "3px"
                                                        }}
                                                        className={`btn btn-secondary`}
                                                    >
                                                        <i className="icofont icofont-ui-edit f-14"></i>
                                                    </button>
                                                )}

                                                <button
                                                    onClick={() => handleDelete(rowData.id_agreement)}
                                                    title="Eliminar"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginRight: "3px"
                                                    }}
                                                    className={`btn btn-danger`}
                                                >
                                                    <i className="icofont icofont-ui-delete f-14"></i>
                                                </button>

                                                <button
                                                    onClick={() => downdloadExcel(rowData.id_agreement, id_branch, rowData.id_commercial_line)}
                                                    title="Descargar Precios"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        fontSize: "0.65rem",
                                                        borderRadius: "8px",
                                                        padding: "0",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className={`btn btn-success`}
                                                >
                                                    <i className="fa fa-file-excel-o f-14"></i>
                                                </button>
                                            </div>
                                        );
                                    }}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                />
                            </DataTable>
                        </div>
                    </Col>
                </Card>
            </div>
            <ModalAgreement
                {
                ...{
                    modal, modalTitle, toggle, method, loading,
                    name_company, contract_number, validity, status,
                    saveDelete, saveUpdateStatus,
                    confirmationDelete, isDelete, valueCode, setValueCode
                }
                }
            />
        </Fragment>
    )
}
